module.exports = __webpack_public_path__ + "static/media/NetFundingApplicantPortal.edcc4dca.svg";